import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Navbar />
      <main className="pt-20 min-h-[60vh] flex items-center justify-center"
      >
        <div className="text-center px-4"
        >
          <div className="text-8xl md:text-9xl font-black text-background-200 select-none mb-4 font-heading"
          >
            404
          </div>
          <h1 className="text-xl md:text-2xl font-semibold text-foreground-900 mb-2"
          >
            页面未找到
          </h1>
          <p className="text-sm md:text-base text-foreground-500 mb-8"
          >
            您访问的页面不存在或已被移除
          </p>
          <Link
            to="/"
            className="inline-block px-8 py-3 bg-primary-500 text-background-50 rounded-lg text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            返回首页
          </Link>
        </div>
      </main>
      <Footer />
    </>
  );
}